// extracted by mini-css-extract-plugin
export default {"modal":"RestoreModal_modal__1LQ6o","input":"RestoreModal_input__O9VOj","buttonsWrapper":"RestoreModal_buttonsWrapper__VywKc","btnCancel":"RestoreModal_btnCancel__Vh8qm"};